import { render } from "./PaperDoll.vue?vue&type=template&id=43bd7884&scoped=true"
import script from "./PaperDoll.vue?vue&type=script&lang=ts"
export * from "./PaperDoll.vue?vue&type=script&lang=ts"

import "./PaperDoll.vue?vue&type=style&index=0&id=43bd7884&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43bd7884"

export default script